import { useEsiteCtx } from 'services/esite/context';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocationsQuery } from 'services/locations';
import { getQueryParams } from '../utils/get-locations-query-params';

export interface Coordinates {
  lat: number;
  lng: number;
}
export type LocationsSearch = Coordinates | string;
const useLocations = () => {
  const { storeId, locale } = useEsiteCtx();
  const [searchValue, setSearchValue] = useState<LocationsSearch>('');
  const [isIdle, setIsIdle] = useState(true);
  const [showStoresOutsideOfCountry, setShowStoresOutsideOfCountry] =
    useState(false);
  const queryParams = getQueryParams({
    searchValue,
    showStoresOutsideOfCountry,
    storeId,
    locale
  });

  const { data, isPending, isError, refetch } = useLocationsQuery(queryParams);
  const hideResults = isIdle || isPending || !data?.locations?.length;

  const getLocations = (value: LocationsSearch) => {
    setSearchValue(value);
    setIsIdle(false);
    setShowStoresOutsideOfCountry(false);
  };

  const resetIsIdle = useCallback(() => {
    setIsIdle(true);
  }, []);

  const setExtendMapToggle = useMemo(() => {
    return (toggle: boolean) => setShowStoresOutsideOfCountry(toggle);
  }, []);

  useEffect(() => {
    if (searchValue && showStoresOutsideOfCountry) {
      refetch();
    }

    if (searchValue && !showStoresOutsideOfCountry) {
      refetch();
    }
  }, [showStoresOutsideOfCountry, searchValue, refetch]);

  return {
    getLocations: getLocations,
    hideResults,
    isLoading: isIdle ? false : isPending,
    searchValue: isIdle ? '' : isPending,
    isIdle,
    isError,
    ...(isIdle ? {} : data),
    reset: resetIsIdle,
    isExtendMapToggleChecked:
      data?.isShowToggleForExtendStoreList && showStoresOutsideOfCountry,
    setIsExtendMapToggleChecked: setExtendMapToggle
  };
};

export default useLocations;
